/**
 * Paanam Theme Global JavaScript
 * Handles core UI interactions and global functions.
 */

document.addEventListener('DOMContentLoaded', () => {
  console.log('✅ Paanam Theme initialized.');
  
  // Initialize AOS (Animate on Scroll)
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50
    });
  }
});
